export default __webpack_public_path__ + "static/media/book.37c48580.png";